import React, { useState } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import { Button } from 'react-bootstrap';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';

const UploadSelfAssesmentComp = (props) => {
    // console.log(props.idAccreditation.id);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const [file, setfile] = useState('')

    // const fileToBase64 = (file) => {
    //     if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    //         MySwal.fire({
    //             icon: 'error',
    //             title: 'Oops, Error!',
    //             text: `File Dokumen hanya boleh PDF!`,
    //         });
    //         setDisabled(true);
    //         return false;
    //     }
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             const base64 = reader.result
    //             setBase64String(base64)
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // }


    // const handleUploadSalfAssesment = async () => {
    //     setLoading(true);
    //     setDisabled(true);
    //     if (base64String === '') {
    //         MySwal.fire({
    //             icon: 'error',
    //             title: 'Oops, Error',
    //             text: 'Belum ada file terupload!',
    //         });
    //         return false;
    //     }
    //     let dataObj = {
    //         fileSelfAssesment: base64String,
    //         idKegiatanAkreditasi: props.idAccreditation.id
    //     }
    //     axios({
    //         url: '/skor/submit-self-assesment',
    //         method: 'POST',
    //         data: dataObj,
    //         headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    //     }).then(res => {
    //         console.log(res);
    //         MySwal.fire({
    //             icon: 'success',
    //             title: 'Sukses',
    //             text: 'Berhasil mengimport data!',
    //         });
    //         props.close();
    //     }).catch(err => {
    //         console.log(err)
    //         // MySwal.fire({
    //         //     icon: 'error',
    //         //     title: 'Oops, Error!',
    //         //     text: `Gagal import file.`,
    //         // });
    //         // props.close();
    //     });
    // };

    const handleImportSa = async () => {
        try {

            if (file === '') {
                MySwal.fire({
                    icon: 'error',
                    title: 'Oops, Error',
                    text: 'Belum ada file terupload!'
                })
                return false
            }

            setLoading(true)
            setDisabled(true)
            const formData = new FormData()
            formData.append('fileSelfAssesment', file)

            const d = await axios({
                url: `/skor/submit-self-assesment/${props.idAccreditation.id}`,
                method: 'POST',
                data: formData,
                headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
            })
            console.log(d)
            if (!d) {
                MySwal.fire({
                    icon: 'error',
                    title: 'Oops, Error!',
                    text: `Gagal`
                })
            }
            // .then(res => {
            //     console.log(res)
            //     // return false
            //     if (res?.data?.status === 200) {
            MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Berhasil mengimport data!'
            })
            setLoading(false)
            setDisabled(false)
            props.close()
            //     }
            // }).catch(err => {
            //     setLoading(false)
            //     setDisabled(false)
            //     if (err !== "") {
            //         console.log(err?.response?.data?.message)
            //         MySwal.fire({
            //             icon: 'error',
            //             title: 'Oops, Error!',
            //             text: getApiErrorMessage(err)
            //         })
            //     }
            // });

            // MySwal.fire({
            //     icon: 'success',
            //     title: 'Sukses',
            //     text: 'Berhasil mengimport data!'
            // })
            // props.fetch()
            // props.close()

            // setLoading(false)
            // setDisabled(false)
        } catch (err) {
            // console.log(err?.response?.data?.message)
            MySwal.fire({
                icon: 'error',
                title: 'Oops, Error!',
                text: `File tidak terupload.`
            })
            setLoading(false)
            setDisabled(false)
        }
    }

    return (
        <div>
            <div className="mb-3 row">
                <label htmlFor="filePath" className="col-sm-4 col-form-label" required>
                    File Self Assesment
                </label>
                <div className="col-12">
                    <input
                        type="file"
                        className="form-control"
                        id="fileSelfAssesment"
                        onChange={(e) => setfile(e.target.files[0])}
                    />
                </div>
            </div>
            <div className="mt-5 row">
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                    &nbsp;
                    <Button
                        disabled={disabled}
                        variant="success"
                        size="sm"
                        onClick={() => handleImportSa()}
                    >
                        {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default UploadSelfAssesmentComp;
